import { render, staticRenderFns } from "./InventoryCategoryChart.vue?vue&type=template&id=1406da4e"
import script from "./InventoryCategoryChart.vue?vue&type=script&lang=js"
export * from "./InventoryCategoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports